import { PARTNERSHIP_4 } from '../../core/seats.js';
import { followSuitOrAnything } from '../../core/legality.js';
import { emptyTrick } from '../../core/trick.js';
import { BRIDGE_TRICKS_PER_HAND, DEFAULT_BRIDGE_CONFIG, validateBridgeConfig, } from './config.js';
import { bridgeAuction } from './auction.js';
import { bridgeDealPlan, bridgeDeck, bridgeRanking, bridgeVisibility, dummyOf } from './rules.js';
import { bridgeMatchEnd, bridgeScoreHand } from './scoring.js';
export const bridge = {
    meta: { id: 'bridge', name: 'Bridge', rotation: 'clockwise' },
    defaultConfig: DEFAULT_BRIDGE_CONFIG,
    validateConfig: validateBridgeConfig,
    table: (_config) => PARTNERSHIP_4,
    tricksPerHand: (_config) => BRIDGE_TRICKS_PER_HAND,
    deck: bridgeDeck,
    dealPlan: bridgeDealPlan,
    auction: bridgeAuction,
    ranking: (hand) => bridgeRanking(hand.contract?.strain ?? null),
    legalPlays(hand, seat) {
        const trick = hand.tricks[hand.tricks.length - 1] ?? emptyTrick(0, hand.dealer);
        return followSuitOrAnything(hand.secret.holdings[seat] ?? [], trick, bridgeRanking(hand.contract?.strain ?? null));
    },
    initHandExtra: () => ({ dummyExposed: false }),
    initMatchExtra: () => ({}),
    onContract(hand, table) {
        return {
            extra: { dummyExposed: false },
            pending: null,
            activeSeats: Array.from({ length: table.seatCount }, (_, i) => i),
            // Rules §1.5: the defender on declarer's left leads.
            leader: (hand.contract.declarer + 1) % table.seatCount,
        };
    },
    applyDecision() {
        return { ok: false, error: 'Bridge has no decisions' };
    },
    onCardPlayed(hand, _seat, _card, _nominate) {
        return hand.extra.dummyExposed ? hand.extra : { dummyExposed: true };
    },
    nextLeader: (_hand, winner) => winner,
    scoreHand: bridgeScoreHand,
    /** Rules §1.3: four passes pass the board out, and it scores 0 to 0. */
    onPassedOut: () => ({ kind: 'score' }),
    matchEnd: (state, config) => bridgeMatchEnd(state, config),
    roles(hand, table) {
        const all = Array.from({ length: table.seatCount }, (_, i) => i);
        const contract = hand.contract;
        if (!contract || hand.phase === 'handComplete' || hand.phase === 'abandoned') {
            return { activeSeats: all, controllerOf: all };
        }
        // Rules §1.5: declarer plays both hands; dummy's own client goes read-only.
        const dummy = dummyOf(contract.declarer, table.seatCount);
        return { activeSeats: all, controllerOf: all.map((s) => (s === dummy ? contract.declarer : s)) };
    },
    visibility: bridgeVisibility,
    contractLabel: (contract) => (contract ? contract.label : 'Passed out'),
};
//# sourceMappingURL=module.js.map